import React from "react";
import { Box, Typography, Container, Button } from "@mui/material";

const HeroSection = ({ onBookNow }) => {
  return (
    <Box
      sx={{
        position: "relative",
        backgroundImage:
          "url('/images/decoratingClasses/decorating-class-hero.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: { xs: 400, md: 800 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}>
      <Container sx={{ zIndex: 2 }}>
        <Box
          sx={{
            display: "inline-block",
            backgroundColor: "rgba(255, 255, 255, 0.85)",
            px: { xs: 2, md: 6 },
            py: { xs: 2, md: 4 },
            borderRadius: "16px",
            boxShadow: 3,
          }}>
          <Typography
            variant="h3"
            fontWeight="bold"
            sx={{
              fontSize: { xs: "2rem", md: "3.5rem" },
              mb: { xs: 1.5, md: 2 },
              color: "primary.main",
            }}>
            Cake Decorating Classes
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: "1rem", md: "1.5rem" },
              mb: { xs: 2, md: 3 },
              color: "text.primary",
            }}>
            Learn. Create. Laugh. Take home your masterpiece.
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={onBookNow}
            sx={{
              borderRadius: "999px",
              fontWeight: 600,
              px: 4,
              py: 1.25,
              fontSize: { xs: "0.9rem", md: "1rem" },
              boxShadow: 2,
            }}>
            Book Now
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;
